@if (isPartner$ | async) {
  <div>
    <form [formGroup]="driversSelectionForm">
      <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
        @if (
          (vehicleCoveragesFacade.drivers$ | async).length >
          (vehicleCoveragesFacade.vehicles$ | async)?.length
        ) {
          <h1
            dsContent
            class="bold-header"
            [contentPath]="'policy.newVehicleDriverAssignmentHeaderMoreDriversStep1'"
            data-cy="vehicleDriverSelectionDriverStep1"
          ></h1>
        }
        @if (
          (vehicleCoveragesFacade.drivers$ | async).length <
          (vehicleCoveragesFacade.vehicles$ | async)?.length
        ) {
          <h2
            dsContent
            class="bold-header"
            [contentPath]="'policy.newVehicleDriverAssignmentHeaderFewDrivers'"
          ></h2>
        }
        @if (
          (vehicleCoveragesFacade.drivers$ | async).length ===
          (vehicleCoveragesFacade.vehicles$ | async)?.length
        ) {
          <h2
            dsContent
            class="bold-header"
            [contentPath]="'policy.newVehicleDriverAssignmentHeaderEqualOrMoreDrivers'"
            data-cy="vehicleDriverSelectionWhoDrivesEach"
          ></h2>
        }
        @if (
          (vehicleCoveragesFacade.drivers$ | async).length >
            (vehicleCoveragesFacade.vehicles$ | async)?.length &&
          (vehicleCoveragesFacade.drivers$ | async).length <
            2 * (vehicleCoveragesFacade.vehicles$ | async)?.length
        ) {
          <h2
            dsContent
            class="bold-header"
            [contentPath]="'policy.newVehicleDriverAssignmentHeaderEqualOrMoreDrivers'"
            data-cy="vehicleDriverSelectionWhoDrivesEach"
          ></h2>
        }
        @if (
          (vehicleCoveragesFacade.drivers$ | async).length ===
          2 * (vehicleCoveragesFacade.vehicles$ | async)?.length
        ) {
          <h2
            dsContent
            class="bold-header"
            [contentPath]="'policy.newVehicleDriverAssignmentHeaderEqualOrMoreDrivers'"
            data-cy="vehicleDriverSelectionWhoDrivesEach"
          ></h2>
        }
        <div class="margin-top-20 margin-bottom-20">
          @if (
            (vehicleCoveragesFacade.drivers$ | async).length >=
            (vehicleCoveragesFacade.vehicles$ | async)?.length
          ) {
            <div>
              @for (vehicle of vehicleCoveragesFacade.vehicles$ | async; track vehicle) {
                <div>
                  <ds-driver-assignment
                    data-cy="vehicleDriverSelection"
                    [drivers]="vehicleCoveragesFacade.drivers$ | async"
                    [form]="driversSelectionForm"
                    [newVehicle]="vehicle"
                    (selectionChange)="driverAssignment($event)"
                    [filteredDrivers]="vehicleCoveragesFacade.filteredDrivers$ | async"
                    [newDrivers]="vehicleCoveragesFacade.drivers$ | async"
                    [selectedId]="vehicleCoveragesFacade.selectedId$ | async"
                    [isPartner]="isPartner$ | async"
                    [driverAssignments]="vehicleCoveragesFacade.driverAssignments$ | async"
                    (updateDriverAssignments)="
                      vehicleCoveragesFacade.updateDriverAssignments($event)
                    "
                  ></ds-driver-assignment>
                </div>
              }
            </div>
          }
          @if (
            (vehicleCoveragesFacade.drivers$ | async).length <
            (vehicleCoveragesFacade.vehicles$ | async)?.length
          ) {
            <div>
              @for (driver of vehicleCoveragesFacade.drivers$ | async; track driver) {
                <div>
                  <ds-vehicle-assignment
                    data-cy="vehicleDriverSelection"
                    [newDriver]="driver"
                    [form]="driversSelectionForm"
                    [vehicles]="vehiclesList$ | async"
                    (selectionChange)="vehicleAssignment($event)"
                    [filteredVehicles]="vehicleCoveragesFacade.filteredVehicles$ | async"
                    [newVehicles]="vehicleCoveragesFacade.vehicles$ | async"
                    [selectedId]="vehicleCoveragesFacade.selectedId$ | async"
                    [isPartner]="isPartner$ | async"
                    [driverAssignments]="vehicleCoveragesFacade.driverAssignments$ | async"
                    (updateDriverAssignments)="
                      vehicleCoveragesFacade.updateDriverAssignments($event)
                    "
                  >
                  </ds-vehicle-assignment>
                </div>
              }
            </div>
          }
        </div>
        <div class="row">
          @if (
            (vehicleCoveragesFacade.drivers$ | async).length <
            (vehicleCoveragesFacade.vehicles$ | async)?.length
          ) {
            <div
              class="column twelve caption"
              dsContent
              [contentPath]="'policy.newVehicleDriverAssignmentHelpText'"
              data-cy="newVehicleDriverAssignmentHelpText"
            ></div>
          }
          @if (
            (vehicleCoveragesFacade.drivers$ | async).length >=
            (vehicleCoveragesFacade.vehicles$ | async)?.length
          ) {
            <div
              class="column twelve caption"
              dsContent
              [contentPath]="'policy.newVehicleDriverAssignmenMoreDriverstHelpText'"
            ></div>
          }
        </div>
      </div>
      <div class="row column twelve lg-push-two md-eight md-push-two">
        <call-to-action
          [displayBackButton]="true"
          [tertiaryButtonName]="'Cancel'"
          [disabled]="driversSelectionForm.invalid"
          [primaryButtonName]="(isPartner$ | async) ? 'Next Step' : 'Continue'"
          (primaryEvent)="submitDriverSelectionForm()"
          (tertiaryEvent)="cancelEvent.emit(true)"
          (backEvent)="goBackOneStep()"
        ></call-to-action>
      </div>
    </form>
    <ds-amfam-vehicle-assignment-modal
      [vehicleAssignmentModalId]="switchDriverModalId"
      (cancelEvent)="cancelDriverAssignment(driverForAssignment, vehicleForAssignment)"
      (switchEvent)="switchDrivers(driverForAssignment, vehicleForAssignment)"
    ></ds-amfam-vehicle-assignment-modal>
  </div>
}
@if ((isPartner$ | async) === false) {
  <div>
    <form [formGroup]="driversSelectionForm">
      <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
        @if ((driverNamesList$ | async).length > (vehiclesList$ | async)?.length) {
          <h1
            dsContent
            class="bold-header"
            [contentPath]="'policy.newVehicleDriverAssignmentHeaderMoreDriversStep1'"
            data-cy="vehicleDriverSelectionDriverStep1"
          ></h1>
        }
        @if ((driverNamesList$ | async).length < (vehiclesList$ | async)?.length) {
          <h2
            dsContent
            class="bold-header"
            [contentPath]="'policy.newVehicleDriverAssignmentHeaderFewDrivers'"
          ></h2>
        }
        @if ((driverNamesList$ | async).length === (vehiclesList$ | async)?.length) {
          <h2
            dsContent
            class="bold-header"
            [contentPath]="'policy.newVehicleDriverAssignmentHeaderEqualOrMoreDrivers'"
            data-cy="vehicleDriverSelectionWhoDrivesEach"
          ></h2>
        }
        @if (
          (driverNamesList$ | async).length > (vehiclesList$ | async)?.length &&
          (driverNamesList$ | async).length < 2 * (vehiclesList$ | async)?.length
        ) {
          <h2
            dsContent
            class="bold-header"
            [contentPath]="'policy.newVehicleDriverAssignmentHeaderEqualOrMoreDrivers'"
            data-cy="vehicleDriverSelectionWhoDrivesEach"
          ></h2>
        }
        @if ((driverNamesList$ | async).length === 2 * (vehiclesList$ | async)?.length) {
          <h2
            dsContent
            class="bold-header"
            [contentPath]="'policy.newVehicleDriverAssignmentHeaderEqualOrMoreDrivers'"
            data-cy="vehicleDriverSelectionWhoDrivesEach"
          ></h2>
        }
        <div class="margin-top-20 margin-bottom-20">
          @if ((driverNamesList$ | async).length >= (vehiclesList$ | async)?.length) {
            <div>
              @for (vehicle of vehiclesList$ | async; track vehicle) {
                <div>
                  <ds-driver-assignment
                    data-cy="vehicleDriverSelection"
                    [drivers]="driverNamesList$ | async"
                    [form]="driversSelectionForm"
                    [vehicle]="vehicle"
                    (selectionChange)="driverAssignment($event)"
                  >
                  </ds-driver-assignment>
                </div>
              }
            </div>
          }
          @if ((driverNamesList$ | async).length < (vehiclesList$ | async)?.length) {
            <div>
              @for (driver of driverNamesList$ | async; track driver) {
                <div>
                  <ds-vehicle-assignment
                    data-cy="vehicleDriverSelection"
                    [driver]="driver"
                    [form]="driversSelectionForm"
                    [vehicles]="vehiclesList$ | async"
                    (selectionChange)="vehicleAssignment($event)"
                  ></ds-vehicle-assignment>
                </div>
              }
            </div>
          }
        </div>
        <div class="row">
          @if ((driverNamesList$ | async).length < (vehiclesList$ | async)?.length) {
            <div
              class="column twelve caption"
              dsContent
              [contentPath]="'policy.newVehicleDriverAssignmentHelpText'"
              data-cy="newVehicleDriverAssignmentHelpText"
            ></div>
          }
          @if ((driverNamesList$ | async).length >= (vehiclesList$ | async)?.length) {
            <div
              class="column twelve caption"
              dsContent
              [contentPath]="'policy.newVehicleDriverAssignmenMoreDriverstHelpText'"
            ></div>
          }
        </div>
      </div>
      <div class="row column twelve lg-push-two md-eight md-push-two">
        <call-to-action
          [displayBackButton]="true"
          [tertiaryButtonName]="'Cancel'"
          [disabled]="driversSelectionForm.invalid"
          [primaryButtonName]="(isPartner$ | async) ? 'Next Step' : 'Continue'"
          (primaryEvent)="submitDriverSelectionForm()"
          (tertiaryEvent)="cancelEvent.emit(true)"
          (backEvent)="goBackOneStep()"
        ></call-to-action>
      </div>
    </form>
    <ds-amfam-vehicle-assignment-modal
      [vehicleAssignmentModalId]="switchDriverModalId"
      (cancelEvent)="cancelDriverAssignment(driverForAssignment, vehicleForAssignment)"
      (switchEvent)="switchDrivers(driverForAssignment, vehicleForAssignment)"
    ></ds-amfam-vehicle-assignment-modal>
  </div>
}
